import { useMutation, useQueryClient } from '@tanstack/react-query';

type SyncResponse = {
  success: boolean;
  error?: string;
};

export default function useSyncSharedJobPostListItem() {
  const queryClient = useQueryClient();
  const token = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || '';

  return useMutation({
    mutationFn: async (listId: number): Promise<SyncResponse> => {
      const response = await fetch(`/agent/api/shared_job_post_lists/${listId}/sync_list`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token,
        },
      });

      const data: SyncResponse = await response.json();
      if (!response.ok) {
        throw new Error(data.error || '同期に失敗しました');
      }
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/agent/api/shared_job_post_lists'] });
    },
  });
}
